import React from 'react'

export default function Copied(props) {
  const visible = props.visible
  const text = props.text ? props.text : 'Copied!'
  const gap = props.gap ? props.gap : 10
  const snapToMy = props.snapToMy ? props.snapToMy : 'left'

  const position = snapToMy === 'right' ? { right: gap } : { left: gap }

  return (
    <div className="relative">
      <span
        className={`absolute top-1/2 z-10 -translate-y-1/2 rounded-full bg-mauve-900 px-2 py-1 text-xs text-white transition ${
          visible ? 'opacity-100' : 'pointer-events-none opacity-0'
        }`}
        style={position}
      >
        {text}
      </span>
    </div>
  )
}
